import { vars } from "@common/styles";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import styled from "styled-components";

export const MainContainerCard = styled(Flex)`
  flex: 1;
  background: linear-gradient(#202020, #202020) padding-box padding-box,
    linear-gradient(161.27deg, #3a3a3c 0%, #202020 50.64%) border-box border-box;
  border: 1px solid transparent;
  border-radius: 20px;
  padding: 3.2rem 0.8rem 3.2rem 3.2rem;

  &:after {
    content: "";
    position: absolute;
    inset: 0;
    left: 0;
    top: 3.7rem;
    width: 1px;
    height: 4.2rem;
    background: linear-gradient(
      0deg,
      rgba(44, 44, 46, 0.7) 0%,
      rgba(101, 82, 255, 0.7) 50.2%,
      rgba(44, 44, 46, 0.7) 100%
    );
  }
`;

export const BasicsContainerCard = styled(Flex)`
  flex: 0 0 27.2rem;
  background: linear-gradient(#202020, #202020) padding-box padding-box,
    linear-gradient(161.27deg, #3a3a3c 0%, #202020 50.64%) border-box border-box;
  border: 1px solid transparent;
  border-radius: 20px;
  padding: 3.2rem;

  flex-direction: column;
  overflow: hidden auto;
`;

export const ContainerScroll = styled(Flex)`
  flex: 1;
  overflow: hidden scroll;
  padding-right: 1rem;
`;

export const DropOverlay = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  color: ${vars.colors.pureWhite};
  align-items: center;
  justify-content: center;
  font-size: 20px;
  pointer-events: none;
  border: 1px solid ${vars.colors.orange};
  background: #ff9f0a1a;
  border-radius: 10px;
`;
